import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M4 6l16 0","key":"svg-0"}],["path",{"d":"M4 18l5 0","key":"svg-1"}],["path",{"d":"M4 12h13a3 3 0 0 1 0 6h-4l2 -2m0 4l-2 -2","key":"svg-2"}]]

/**
 * IconTextWrap
 * @preview ![img](data:image/svg+xml;base64,PHN2ZwogIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIKICB3aWR0aD0iMjQiCiAgaGVpZ2h0PSIyNCIKICB2aWV3Qm94PSIwIDAgMjQgMjQiCiAgZmlsbD0ibm9uZSIKICBzdHJva2U9ImN1cnJlbnRDb2xvciIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCiAgY2xhc3M9Imljb24gaWNvbi10YWJsZXIgaWNvbnMtdGFibGVyLW91dGxpbmUgaWNvbi10YWJsZXItdGV4dC13cmFwIgo+CiAgPHBhdGggc3Ryb2tlPSJub25lIiBkPSJNMCAwaDI0djI0SDB6IiBmaWxsPSJub25lIiAvPgogIDxwYXRoIGQ9Ik00IDZsMTYgMCIgLz4KICA8cGF0aCBkPSJNNCAxOGw1IDAiIC8+CiAgPHBhdGggZD0iTTQgMTJoMTNhMyAzIDAgMCAxIDAgNmgtNGwyIC0ybTAgNGwtMiAtMiIgLz4KPC9zdmc+) - https://tabler.io/icons/icon/text-wrap
 * @see https://docs.tabler.io/icons/libraries/react - Documentation
 *
 */
const IconTextWrap = createReactComponent('outline', 'text-wrap', 'TextWrap', __iconNode);

export default IconTextWrap;